import { Spinner } from '@lovoldsystem/ui'
import { useEffect, useState } from 'react'
import { useUserCtx } from 'src/hooks/context-hooks'
import { Stack, useTheme } from '@mui/material'
import { Navigate, Route, Routes } from 'react-router-dom'
import SystemProjectRoleGuard from 'src/guards/SystemProjectAdminRoleGuard'
import { AppRoutesNavigation, AppRoutesRouter } from 'src/app-routes'
import { axios } from 'src/axios'
import ProjectAdminUsers from 'src/screens/project/containers/system-project-admin/ProjectAdminUsers'
import CustomerWithLocalities from 'src/screens/project/containers/system-project-admin/CustomerWithLocalities.tsx'

const ProjectAdminRoutes = () => {
  const { user, isLoadingUser } = useUserCtx()
  const [permissions, setPermissions] = useState(-1)
  const theme = useTheme()

  useEffect(() => {
    if (user) {
      setPermissions(user.permission)
      axios.defaults.headers['X-Permissions'] = user.encryptedPermission
    }
  }, [user])

  if (isLoadingUser || permissions === -1) return <Spinner size={'small'} />

  return (
    <Stack
      style={{ backgroundColor: theme.palette.backgroundMain[theme.palette.mode] }}
      width={'100%'}
      minHeight={'calc(100vh - 96px)'}
      className="pb-4-core"
    >
      <SystemProjectRoleGuard isNavigateToUnAuthorized>
        <Routes>
          <Route path={AppRoutesRouter.ProjectAdmin.users} element={<ProjectAdminUsers />} />
          <Route path={AppRoutesRouter.ProjectAdmin.customers} element={<CustomerWithLocalities />} />
          <Route
            path={AppRoutesRouter.ProjectAdmin.customers}
            element={<Navigate to={AppRoutesNavigation.ProjectAdmin.users} />}
          />

          <Route path="*" element={<Navigate to={AppRoutesNavigation.ProjectAdmin.users} />} />
        </Routes>
      </SystemProjectRoleGuard>
    </Stack>
  )
}

export default ProjectAdminRoutes
